if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

class CarouselPortrait extends HTMLElement {
  constructor() {
    super();
    this.slidesContainer = this.querySelector('.carousel-portrait__slides');
    this.slides = this.querySelectorAll('.carousel-portrait__slide');
    this.prevButton = this.querySelector('.carousel-arrow--prev');
    this.nextButton = this.querySelector('.carousel-arrow--next');
    this.autoplayDelay = 4000;
    this.currentSlide = 0;
    this.autoplayTimer = null;
    this.isTransitioning = false;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.dragThreshold = 50;
    
    if (this.slides.length > 1) {
      this.initCarousel();
    } else {
      if (this.prevButton && this.nextButton) {
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = 'none';
      }
    }
  }

  initCarousel() {
    this.createDots();
    this.showSlide(0);
    this.startAutoplay();
    this.addSwipeEvents();
    this.addArrowEvents();
    this.addDragEvents();
    
    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
  }

  addArrowEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.previousSlide();
        this.restartAutoplay();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.nextSlide();
        this.restartAutoplay();
      });
    }
  }

  addDragEvents() {
    this.slidesContainer.addEventListener('mousedown', this.startDrag.bind(this));
    this.slidesContainer.addEventListener('mousemove', this.drag.bind(this));
    this.slidesContainer.addEventListener('mouseup', this.endDrag.bind(this));
    this.slidesContainer.addEventListener('mouseleave', this.endDrag.bind(this));
    
    this.slidesContainer.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  }

  addSwipeEvents() {
    this.slidesContainer.addEventListener('touchstart', (e) => {
      this.startDrag(e.touches[0]);
    });

    this.slidesContainer.addEventListener('touchmove', (e) => {
      this.drag(e.touches[0]);
    });

    this.slidesContainer.addEventListener('touchend', this.endDrag.bind(this));
  }

  startDrag(e) {
    if (this.isTransitioning) return;
    
    this.isDragging = true;
    this.startX = this.getClientX(e);
    this.currentX = this.startX;
    this.slidesContainer.style.cursor = 'grabbing';
    this.slidesContainer.style.transition = 'none';
    this.stopAutoplay();
  }

  drag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    const clientX = this.getClientX(e);
    const diff = clientX - this.currentX;
    this.currentX = clientX;
    
    const slideWidth = this.slidesContainer.offsetWidth;
    const currentTranslate = -this.currentSlide * slideWidth;
    const newTranslate = currentTranslate + diff;
    
    this.slidesContainer.style.transform = `translateX(${newTranslate}px)`;
  }

  endDrag() {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.slidesContainer.style.cursor = 'grab';
    this.slidesContainer.style.transition = 'transform 0.5s ease-in-out';
    
    const dragDistance = this.currentX - this.startX;
    const slideWidth = this.slidesContainer.offsetWidth;
    const dragPercentage = Math.abs(dragDistance) / slideWidth;
    
    if (dragPercentage > 0.2) {
      if (dragDistance > 0) {
        this.previousSlide();
      } else {
        this.nextSlide();
      }
    } else {
      this.showSlide(this.currentSlide);
    }
    
    this.restartAutoplay();
  }

  getClientX(e) {
    return e.clientX || e.pageX;
  }

  createDots() {
    if (this.slides.length <= 1) return;
    
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'carousel-dots';
    
    this.dots = [];
    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel-dot';
      if (index === 0) dot.classList.add('active');
      dot.innerHTML = `<span class="visually-hidden">Slide ${index + 1}</span>`;
      dot.addEventListener('click', () => {
        this.showSlide(index);
        this.restartAutoplay();
      });
      dotsContainer.appendChild(dot);
      this.dots.push(dot);
    });
    
    this.querySelector('.carousel-portrait__container').appendChild(dotsContainer);
  }

  showSlide(index) {
    if (this.isTransitioning && !this.isDragging) return;
    if (this.slides.length === 0) return;
    
    if (index >= this.slides.length) index = 0;
    if (index < 0) index = this.slides.length - 1;
    
    this.isTransitioning = true;
    
    const slideWidth = this.slidesContainer.offsetWidth;
    this.slidesContainer.style.transform = `translateX(-${index * slideWidth}px)`;
    
    this.currentSlide = index;
    
    if (this.dots) {
      this.dots.forEach(dot => dot.classList.remove('active'));
      this.dots[index].classList.add('active');
    }
    
    setTimeout(() => {
      this.isTransitioning = false;
    }, 500);
  }

  nextSlide() {
    this.showSlide(this.currentSlide + 1);
  }

  previousSlide() {
    this.showSlide(this.currentSlide - 1);
  }

  startAutoplay() {
    if (this.slides.length <= 1) return;
    
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.nextSlide();
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('carousel-portrait')) {
  customElements.define('carousel-portrait', CarouselPortrait);
}